import api from '@/api/axios.js'
const getCacheName=function(editCfg){
    let str=JSON.stringify(editCfg.dataCfg)
    str=str.replace(/"params":|"url":|"sc":|"|:|{|}|,|\//g,"")
    return str
}
// initial state
// shape: [{ id, quantity }]
const state = {
    dropCacheData:{}
  }

  // getters
  const getters = {
    getDropCacheData: (state, getters, rootState) => {
      return state.dropCacheData;
    },
    getDropDataById: (state, getters, rootState) => (col,id) => {
        let cacheName=getCacheName(col.editCfg),
        data=state.dropCacheData[cacheName]||{};
        return data[id];
    },
    getDropDataList: (state, getters, rootState) => (col) =>{
        let cacheName=getCacheName(col.editCfg),
        data=state.dropCacheData[cacheName]||{};
        return data.dataList||[];
    }
  }
  
  // actions
  const actions = {
    getApiBaseStatus ({ state, commit }, product) {
      api.post('roleManage/listRoleType', params, r => {
          const list=r.result||[];
          commit('baseStatus', r.result);
      },null,"permission")
    },
    setDropCacheData({ state, commit }, data){
        let col=data.col,row=data.row
        if(col.editCfg.onBeforeInitData){
            col.editCfg.onBeforeInitData(col,row)
        }
        let cacheName=getCacheName(col.editCfg),
        dropCacheData=state.dropCacheData[cacheName],
        cacheData={};
        if(dropCacheData){
            // if(dropCacheData.col.indexOf(col.key)<0)
            return 
        }else{
            // let cacheData={col:[col.key]}
            // commit('setDropCacheData', {cacheName,cacheData});
            commit('setDropCacheData', {cacheName});
        }
        if(state.dropCacheData[col[key]])return false;
        //获取列配置editCfg
        let editCfg=col.editCfg,
        key=editCfg.key,
        label=editCfg.label;
        //editCfg使用静态数据处理
        if(editCfg.value&&editCfg.value.length>0){
            editCfg.value.filter(item=>{
                cacheData[item[key]]=item[label]
            })
            commit('setDropCacheData', {cacheName,cacheData});
        }else{
            let dataCfg=editCfg.dataCfg||{};
            let params=dataCfg.params||{};
            //如果缓存中都有数据了，就不需要调用服务
            api.post({
                sc:dataCfg.sc,
                url:dataCfg.url,
                params:params,
                success: r => {
                    if(editCfg.onBeforeSetDataList){
                        editCfg.onBeforeSetDataList(r)
                    }
                    let list=r.result||[]
                    if(list.length>0){
                        list.filter(item=>{
                            if(item){
                                cacheData[item[key]]=item[label]
                            }
                        })
                        cacheData.dataList=list
                        commit('setDropCacheData', {cacheName,cacheData});
                    }
                }
            })
        }
    },
  }
  
  // mutations
  const mutations = {
    setDropCacheData (state, {cacheName,cacheData}) {
        cacheData=cacheData||{}
        state.dropCacheData={...state.dropCacheData,[cacheName]:cacheData}
    }
  }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    mounted() {
      
    },
  }


// WEBPACK FOOTER //
// ./src/store/modules/components.js